import Image from 'next/image';

import img1 from '../../../../assets/1.svg';
import img2 from '../../../../assets/2.svg';
import img3 from '../../../../assets/3.svg';
import img4 from '../../../../assets/4.svg';
import cls from './Benefits.module.scss';

export const Benefits = () => {
  return (
    <div className={cls.wrap}>
      <div className={cls.item}>
        <Image
          src={img1}
          alt={'Гарантия 2 года'}
        />
      </div>
      <div className={cls.item}>
        <Image
          src={img2}
          alt={'0 рублей за доставку по России'}
        />
      </div>
      <div className={cls.item}>
        <Image
          src={img3}
          alt={'100% страховка заказа'}
        />
      </div>
      <div className={cls.item}>
        <Image
          src={img4}
          alt={'Проверенные тк'}
        />
      </div>
    </div>
  );
};
